import { useLocalizationExtension } from '../../../context/Localization/localization';
import { PhoneOrEmailFieldValidationProps } from './PhoneOrEmailFieldValidation.types';
import * as Yup from 'yup';

/**
 * This function handles the phone or email field validation for the useField formik validator.
 *
 * @param name - {@link PhoneOrEmailFieldValidationProps.name name} description.
 * @param label - {@link PhoneOrEmailFieldValidationProps.label label} description.
 * @param required - {@link PhoneOrEmailFieldValidationProps.required required} description.
 */
const PhoneOrEmailFieldValidation = ({
    name,
    label,
    required,
}: PhoneOrEmailFieldValidationProps) => {
    const { formatRequired, emailOrPhoneInvalid } = useLocalizationExtension();

    return async (value: string) => {
        const formattedValuePhone = value.replace(/[^\d]/g, '');

        if (required && (!value || value.length < 1)) {
            return formatRequired(label || name);
        }
        else if ((formattedValuePhone.length !== 10 || !Yup.string()
            .phone()
            .isValidSync(formattedValuePhone)) && !Yup.string()
            .email()
            .isValidSync(value)) {
            return emailOrPhoneInvalid;
        }

        return undefined;
    };
};

export default PhoneOrEmailFieldValidation;